import { useRequest } from '@mgm/common/lib';
import { TAxiosError } from '@mgm/common/types';
import { CONTROLLERS } from '../utils/enums';
import { TAddShiftReq, TGetSheetsReq, TUpdateShiftReq } from '../types/requests';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function SheetsController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.TIMESHEETS;

  const getSheets = <T>(data: TGetSheetsReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/data`, options);
  };

  const deleteShift = <T>(data: Record<string, string | number>): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/delete`, options);
  };

  const addShift = <T>(data: TAddShiftReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/add`, options);
  };

  const updateShift = <T>(data: TUpdateShiftReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/update`, options);
  };

  return {
    getSheets,
    deleteShift,
    addShift,
    updateShift,
  };
}
